import { featureIsAvailable } from "../../shared/feature-flags";

const TOGETHER_AVAILABILITY =
  import.meta.env.VITE_TOGETHER_AVAILABILITY ?? "local";

export function togetherIsAvailableInBrowser(
  hostname = window.location.hostname,
) {
  return featureIsAvailable(TOGETHER_AVAILABILITY, hostname);
}
